/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './homePage.module.scss';
import { HomePageInterface } from './homePageTypes';
import Filter from '../../pageParts/filter/filter';
import {
  cities,
  category,
  MODAL_TYPES,
  ListingDataInterface,
} from '../../constants/constants';
import Line from '../../UI/line/line';
import Grid from '../../pageParts/grid/grid';
import Pagination from '../../pageParts/pagination/pagination';
import PopUpLogin from '../../pageParts/popUp/popUpLogin';
import PopUpRegistration from '../../pageParts/popUp/popUpRegistration';
import { useDispatch, useSelector } from '../..';
import {
  getFilteredListings,
  getListings,
  like,
  setFavoriteOnCard,
  setPageNumber,
  unlike,
} from '../../service/ListingData';
import { SearchDataInterface } from '../../pageParts/filter/filterTypes';

const HomePage: React.FC<HomePageInterface> = ({
  maxListings,
  modal,
  closePopupLogin,
  closePopupRegistration,
  afterLogin,
  afterRegistration,
  loginType,
  listingClick,
  onCardEdit,
  onNoAccount,
  returnToLogin,
}) => {
  const [data, setData] = useState<ListingDataInterface[] | []>([]);
  const listingData = useSelector((state) => state.listingData.listings) || [];
  const dispatch = useDispatch();
  const pageNumber = useSelector((state) => state.listingData.pageNumber);
  const searchData = useSelector((state) => state.listingData.searchData);
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 620 }),
    mobile: useMediaQuery({ maxWidth: 620 }),
  };
  const [isModal, setIsModal] = useState<MODAL_TYPES | null>(null);
  const user = useSelector((state) => state.userData.user);

  useEffect(() => {
    console.log('VIVID');
    dispatch(setPageNumber(1));
    dispatch(getListings(1));
  }, []);

  useEffect(() => {
    setIsModal(modal);
  }, [modal]);

  useEffect(() => {
    if (listingData) {
      setData(listingData);
    }
  }, [listingData]);

  const ownerIdCheck = (id: number) => user.id === id;

  const onFavoriteClick = (id: number) => {
    const offer = data.find((offer) => offer.id === id);

    if (offer!.isFavorite) {
      dispatch(unlike(id));
      dispatch(setFavoriteOnCard(id));
    } else {
      dispatch(like(id));
      dispatch(setFavoriteOnCard(id));
    }
  };

  const isFavorite = (id: number) => {
    const offer = data.find((offer) => offer.id === id);

    if (offer!.isFavorite) {
      return true;
    }
    return false;
  };

  const pageMove = (n: number) => {
    console.log(searchData);
    if (searchData) {
      dispatch(getFilteredListings({ filters: searchData, page: n }));
      dispatch(setPageNumber(n));
    } else {
      dispatch(setPageNumber(n));
      dispatch(getListings(n));
    }
  };

  return (
    <div
      className={
        resolution.DesktopOrLaptop
          ? style.homepageStyle
          : style.homepageStyleMob
      }
    >
      {(resolution.mobile && !isModal) || resolution.DesktopOrLaptop ? (
        <>
          <Filter optionCities={cities} optionTypes={category} />
          <Line width={1320} height={1} />
          <Grid
            listings={listingData}
            onClick={listingClick}
            onEdit={onCardEdit}
            onFavorite={onFavoriteClick}
            isOwner={ownerIdCheck}
            alreadyFavorite={isFavorite}
          />
          <Pagination clicker={(n) => pageMove(n)} pageNumber={pageNumber} />
          <Line width={1320} height={1} />
        </>
      ) : null}
      {isModal === MODAL_TYPES.LOG_IN && (
        <div
          className={resolution.DesktopOrLaptop ? style.modal : style.modalMob}
        >
          <PopUpLogin
            type={loginType}
            error={false}
            onClose={closePopupLogin}
            onNoAccount={onNoAccount}
            onSubmit={afterLogin}
          />
        </div>
      )}
      {isModal === MODAL_TYPES.REGISTRATION && (
        <div
          className={resolution.DesktopOrLaptop ? style.modal : style.modalMob}
        >
          <PopUpRegistration
            error={false}
            onClose={closePopupRegistration}
            toLogin={returnToLogin}
            onSubmit={afterRegistration}
          />
        </div>
      )}
    </div>
  );
};

export default HomePage;
